/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { lineClamp } from '@common/cssUtilities';
import StarIcon from '@stories/atoms/Icons/starIcon.svg';
import { media } from '@stories/theming/settings';

import type { GetHygraphIcpDataQuery } from '@gql/hygraph/graphql';

export type TRatingCard = NonNullable<GetHygraphIcpDataQuery['category']>['reviews'][0] & {
  fontSize?: string;
};

const RatingCard: React.FC<TRatingCard> = ({ header, rating, description, author, date, fontSize }) => {
  const dateValue = new Date(date).toLocaleDateString('de-DE', { dateStyle: 'medium' });
  return (
    <div
      css={(t) => ({
        width: '70%',
        border: `1px solid ${t.color.grey.g92}`,
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        padding: '1rem',
        margin: '0 0.5rem',
        [media('desktop')]: {
          width: 'calc(25% - 1rem)'
        }
      })}
    >
      <h3
        css={() => ({
          fontWeight: 'bold',
          lineHeight: '125%',
          ...lineClamp(2)
        })}
      >
        {header}
      </h3>
      <div css={css({ display: 'flex', marginRight: '.25rem', margin: '0.75rem 0' })}>
        {[...Array(Math.ceil(rating))].map((_, i) => (
          <StarIcon
            key={i}
            css={(theme) => ({
              color: theme.color.primary,
              height: '1rem',
              width: '1rem'
            })}
          />
        ))}
      </div>
      <div
        css={(t) => ({
          marginBottom: '1rem',
          ...(fontSize ? { fontSize: fontSize } : t.font.small),
          ...lineClamp(6)
        })}
      >
        {`"${description}"`}
      </div>
      <div
        css={(t) => ({
          textAlign: 'right',
          marginTop: 'auto',
          color: t.color.grey.g60,
          width: '100%',
          ...(fontSize ? { fontSize: fontSize } : t.font.small)
        })}
      >
        {`${author} - ${dateValue}`}
      </div>
    </div>
  );
};

export default RatingCard;
